import { Typography } from '@mui/material'
import Stack from '@mui/material/Stack'
import { CarrierVisitStatusChip } from '@operations/components/chips/CarrierVisitStatusChip'
import { getCarrierVisitViewStatus } from '@operations/utils/helper'
import { useTranslate } from '@tolgee/react'
import { OptionsButton, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { CarrierVisitViewModel } from '../../models/work-instruction-view.model'
import { WorkInstructionUIStore } from '../../stores/work-instruction.ui-store'
import { ControlRoomAccordion } from '../molecules/ControlRoomAccordion'
import { WorkInstructionCranesAccordion } from '../molecules/WorkInstructionCranesAccordion'

interface Props {
  store: WorkInstructionUIStore
}
export const WorkInstructionCarriers = observer(({ store }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const calculateCarrierVisitViewStatus = (carrierVisit: CarrierVisitViewModel) => {
    return getCarrierVisitViewStatus(carrierVisit.status, carrierVisit.atb)
  }

  return (
    <Stack sx={{ maxHeight: 'calc(100vh - 205px)', overflowY: 'auto' }}>
      {store.filteredCarrierVisits.map(carrierVisit => (
        <ControlRoomAccordion
          key={`carrier-visit-${carrierVisit.id}`}
          isSelected={store.selectedVisitId === carrierVisit.id}
          title={carrierVisit.carrierName}
          subtitle={carrierVisit.vesselVisitNumber}
          onChange={() => store.setSelectedVisitId(carrierVisit.id)}
          hasDetails={store.selectedTabType === 'vessel'}
          rightSummaryRender={
            <Stack flexDirection='row' alignItems='center' gap={theme.customSpacing.xxs}>
              <CarrierVisitStatusChip status={calculateCarrierVisitViewStatus(carrierVisit)} />
              <OptionsButton
                position='right'
                options={[
                  {
                    label: t('showAll', 'Show All'),
                    onClick: () => store.setSelectedVisitId(carrierVisit.id),
                  },
                ]}
              />
            </Stack>
          }
        >
          <WorkInstructionCranesAccordion
            cranes={carrierVisit.cranes}
            visitStatus={carrierVisit.status}
            selectedCraneId={store.selectedCraneId}
            selectedWorkQueueId={store.selectedWorkQueueId}
            setSelectedCraneId={craneId => store.setSelectedCraneId(craneId)}
            setSelectedWorkQueueId={id => store.setSelectedWorkQueueId(id)}
            setSelectedWorkQueueForAction={workQueue =>
              store.setSelectedWorkQueueForAction(workQueue)
            }
            openNameWQDialog={() => store.setIsNameWorkQueueDialogOpen(true)}
            onStartWorkQueue={workQueue => store.toggleStartWorkQueueDialog(workQueue)}
            onStopWorkQueue={workQueue => store.toggleStopWorkQueueDialog(workQueue)}
          />
        </ControlRoomAccordion>
      ))}

      {!store.filteredCarrierVisits.length && (
        <Typography
          padding={theme.customSpacing.m}
          paddingX={theme.customSpacing.xl}
          variant='body1'
          color='secondary'
          textAlign='center'
        >
          {t('noCarrierVisitsOnTheTerminal', 'No carrier visits found on the terminal')}
        </Typography>
      )}
    </Stack>
  )
})
